import Layout from '@/layout'
import newsRouter from './cms/news'
import webSettingRouter from './cms/websetting'
import sliderRouter from './cms/slider'
import msgleaveRouter from './cms/msgleave'
const cmsRouter = {
  path: 'cms',
  component: Layout,
  name: 'cms',
  meta: {
    title: 'CMS内容管理',
    icon: 'el-icon-s-platform',
    roles: ['root', 'market', 'business']
  },
  children: [
    sliderRouter,
    msgleaveRouter,
    newsRouter,
    webSettingRouter
  ]
}

export default cmsRouter
